import jira from './jira';

let currentSignaturePromise = null;
let lastTimeSignatureRequested = 0;
const REFRESH_INTERVAL = 10 * 60 * 1000; // token is valid for 15 minutes, revalidate if 10 minutes passed

const getRequestSignature = async () => {
  const currentTime = new Date().getTime();
  if (lastTimeSignatureRequested + REFRESH_INTERVAL < currentTime || !currentSignaturePromise) {
    lastTimeSignatureRequested = currentTime;
    const promise = jira.generateSignature({ subject: 'jira_logged_in_user' });
    currentSignaturePromise = promise;
    currentSignaturePromise
      .catch(e => { if (promise === currentSignaturePromise) currentSignaturePromise = null; });
  }

  return currentSignaturePromise;
};

class BaseApi {
  static regularRequest = (method, url, body, headers = {}) => {
    //TODO: refactor all that API Clients stuff, we should do that together with adding Jira Cloud support
    //JIRA: https://pagerduty.atlassian.net/browse/ITS-4962
    //Cypress tests depend on proxy. use proxy in test env instead of fixing all tests
    if (window.Cypress) {
      return jira.proxyRequest(method, url, body, headers, false);
    }

    if (body && typeof body === 'object') {
      body = JSON.stringify(body);
      headers = {
        'Content-Type': 'application/json',
        ...headers,
      };
    }

    return fetch(url, {
      method,
      headers,
      body,
    }).then(standardizeFetchApiResponse);
  };

  static proxyRequest = (method, url, body = null, headers = {}, interpolateBody) => {
    headers = {
      ...headers || {},
      'X-PagerDuty-JIRA-Signature': '{{pd-integration.jwt}}'
    };
    return jira.proxyRequest(method, url, body, headers, interpolateBody);
  }

  static signedRequest = async (method, url, body, headers = {}) => {
    //TODO: refactor all that API Clients stuff, we should do that together with adding Jira Cloud support
    //JIRA: https://pagerduty.atlassian.net/browse/ITS-4961
    //Cypress tests depend on proxy. use proxy in test env instead of fixing all tests
    if (window.Cypress) {
      return await jira.proxyRequest(method, url, body, headers, false);
    }

    const requestSignature = await getRequestSignature();
    return await BaseApi.regularRequest(method, url, body, {
      ...headers || {},
      'X-PagerDuty-JIRA-Signature': requestSignature,
    });
  }

  static jiraRequest = () => {};
}

async function standardizeFetchApiResponse(response) {
  const { headers, url, status } = response;
  const responseText = await response.text();

  return {
    headers,
    url,
    status,
    responseText,
  };
}

window.__base_api_client = window.__cy_stub_base_api_client || BaseApi;
export default window.__base_api_client;
